@if (form) {
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="astral-sidebar-shell" id="lease-row-form" novalidate>
    <div class="astral-sidebar-content astral-stack-l">
      <header>
        @if (!row.id) {
          <h2 class="astral-sidebar-heading">{{ 'LEASE_AGREEMENT_ROW.CREATE_FORM_HEADER' | translate }}</h2>
        }
        @if (row.id) {
          <h2 class="astral-sidebar-heading">{{ 'LEASE_AGREEMENT_ROW.EDIT_FORM_HEADER' | translate }}</h2>
        }
      </header>
      <div class="astral-form-stack">
        <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'" alignItems="end">
          @if (articles) {
            <astral-typeahead
              class="astral-grid-full"
              [control]="form.controls['article']"
              [itemsSource]="articles"
            ></astral-typeahead>
          }
          <astral-toggle [control]="form.controls['oneTimeFee']" [helpText]="'LEASE_AGREEMENT_ROW.HELP_TEXT.ONE_TIME_FEE'"></astral-toggle>
          @if (row.id) {
            <astral-toggle
              [control]="form.controls['voided']"
              [helpText]="'LEASE_AGREEMENT_ROW.HELP_TEXT.VOIDED'"
            ></astral-toggle>
          }
          @if (rentalObjectSelection) {
            <astral-select
              [control]="form.controls['rentalObjectId']"
              [itemsSource]="rentalObjectSelection"
            ></astral-select>
          }
        </astral-layout-group>
        @if (form.controls['oneTimeFee'].value) {
          <astral-layout-group
            [columns]="1"
            [mobileColumns]="1"
            [span]="'full'"
            >
            <astral-select
              [control]="form.controls['period']"
              [itemsSource]="feePeriodSelection"
              [helpText]="'LEASE_AGREEMENT_ROW.HELP_TEXT.ONE_TIME_FEE_PERIOD'"
            ></astral-select>
          </astral-layout-group>
        } @else {
          <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="2" [span]="'full'">
            <astral-date-picker
              [ngClass]="{ hide: form.controls['voided'].value }"
              [control]="form.controls['fromDate']"
            ></astral-date-picker>
            <astral-date-picker [ngClass]="{ hide: form.controls['voided'].value }" [control]="form.controls['toDate']"></astral-date-picker>
            <astral-select
              class="astral-grid-full"
              [control]="form.controls['chargedMonths']"
              [itemsSource]="monthSelection"
              [helpText]="'LEASE_AGREEMENT_ROW.HELP_TEXT.CHARGED_MONTHS'"
              [multiple]="true"
              (valueChange)="chargedMonthsChange($any($event))"
            ></astral-select>
          </astral-layout-group>
        }
        @if (isIndexArticle) {
          <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
            <astral-select class="astral-grid-full" [control]="form.controls['indexClause']" [itemsSource]="indexClauses"></astral-select>
            @if (showIndexMinMaxPercent) {
              <astral-input [control]="form.controls['indexMinYearlyPercent']" [type]="'number'"></astral-input>
            }
            @if (showIndexMinMaxPercent) {
              <astral-input [control]="form.controls['indexMaxYearlyPercent']" [type]="'number'"></astral-input>
            }
            <app-information-block class="astral-grid-full" [text]="indexClauseHelp | translate"></app-information-block>
            <astral-select
              class="astral-grid-full"
              [control]="form.controls['newIndexRentFrom']"
              [itemsSource]="newIndexRentFroms"
            ></astral-select>
          </astral-layout-group>
          <section class="astral-accordion-section">
            <div class="astral-stack-s">
              <h3 class="astral-section-heading astral-accordion-section__heading">{{ 'LEASE_AGREEMENT_ROW.BASE_INDEX' | translate }}</h3>
              <app-information-block [text]="'LEASE_AGREEMENT_ROW.HELP_TEXT.BASE_INDEX' | translate"></app-information-block>
            </div>
            <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
              <app-money-box
                [control]="form.controls['baseIndexAmount']"
                [helpText]="'LEASE_AGREEMENT_ROW.HELP_TEXT.BASE_YEAR_RENT'"
              ></app-money-box>
              <astral-input
                [control]="form.controls['indexShare']"
                [helpText]="'LEASE_AGREEMENT_ROW.HELP_TEXT.INDEX_SHARE'"
                [type]="'number'"
              ></astral-input>
              <astral-input
                [control]="form.controls['baseIndexYear']"
                [helpText]="'LEASE_AGREEMENT_ROW.HELP_TEXT.BASE_INDEX_YEAR'"
                [type]="'number'"
                [inputMode]="'numeric'"
              ></astral-input>
              @if (isQuarterIndex) {
                <astral-select
                  [control]="form.controls['baseIndexMonth']"
                  [itemsSource]="quarterIndexSelection"
                ></astral-select>
              } @else {
                <astral-select [control]="form.controls['baseIndexMonth']" [itemsSource]="monthIndexSelection"></astral-select>
              }
              <astral-input
                class="astral-grid-full"
                label="LEASE_AGREEMENT_ROW.BASE_INDEX_VALUE"
                [value]="getBaseIndexValue"
                [helpText]="'LEASE_AGREEMENT_ROW.HELP_TEXT.BASE_INDEX_VALUE'"
                [readonly]="true"
              ></astral-input>
            </astral-layout-group>
          </section>
          <section class="astral-accordion-section">
            <div class="astral-stack-s">
              <h3 class="astral-section-heading astral-accordion-section__heading">{{ 'LEASE_AGREEMENT_ROW.CURRENT_INDEX' | translate }}</h3>
              <app-information-block [text]="'LEASE_AGREEMENT_ROW.HELP_TEXT.CURRENT_INDEX' | translate"></app-information-block>
            </div>
            <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
              <astral-input
                [control]="form.controls['indexYear']"
                [helpText]="'LEASE_AGREEMENT_ROW.HELP_TEXT.INDEX_YEAR'"
                [type]="'number'"
                [inputMode]="'numeric'"
              ></astral-input>
              @if (!isQuarterIndex) {
                <astral-select
                  [control]="form.controls['indexMonth']"
                  [itemsSource]="monthIndexSelection"
                ></astral-select>
              } @else {
                <astral-select [control]="form.controls['indexMonth']" [itemsSource]="quarterIndexSelection"></astral-select>
              }
              <astral-input
                label="LEASE_AGREEMENT_ROW.INDEX_VALUE"
                [value]="form.controls['indexValue'].value"
                [helpText]="'LEASE_AGREEMENT_ROW.HELP_TEXT.INDEX_VALUE'"
                [readonly]="true"
              ></astral-input>
              <astral-input
                label="LEASE_AGREEMENT_ROW.INDEX_RENT"
                [value]="formattedIndexAmount"
                [helpText]="'LEASE_AGREEMENT_ROW.HELP_TEXT.INDEX_RENT'"
                [readonly]="true"
              ></astral-input>
            </astral-layout-group>
          </section>
        }
        @if (!isIndexArticle) {
          <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
            @if (!form.controls['oneTimeFee'].value) {
              <astral-input
                label="LEASE_AGREEMENT_ROW.TIME_UNIT"
                [value]="articleTimeUnit | translate"
                [helpText]="'LEASE_AGREEMENT_ROW.HELP_TEXT.TIME_UNIT'"
                [readonly]="true"
              ></astral-input>
            }
            @if (showQuantity && !form.controls['oneTimeFee'].value) {
              <astral-input [control]="form.controls['quantity']"></astral-input>
            }
          </astral-layout-group>
          <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="2" [span]="'full'">
            @if ((!isYearRentArticle && (isFullYear || isMonthPeriod)) || form.controls['oneTimeFee'].value) {
              <app-money-box
                [control]="form.controls['amount']"
                [helpText]="'LEASE_AGREEMENT_ROW.HELP_TEXT.AMOUNT'"
              ></app-money-box>
            }
            @if (!form.controls['oneTimeFee'].value) {
              <app-money-box [control]="form.controls['yearRent']"></app-money-box>
            }
          </astral-layout-group>
        }
        @if (isVatArticle) {
          @if (!isIndexArticle && (isFullYear || isMonthPeriod || form.controls['oneTimeFee'].value)) {
            <astral-layout-group
              [columns]="3"
              [tabletColumns]="2"
              [mobileColumns]="1"
              [span]="'full'"
              >
              <app-money-box [control]="form.controls['vat']"></app-money-box>
              <app-money-box [control]="form.controls['amountIncVat']"></app-money-box>
            </astral-layout-group>
          }
          @if (!form.controls['oneTimeFee'].value) {
            <astral-layout-group
              [columns]="3"
              [tabletColumns]="2"
              [mobileColumns]="1"
              [span]="'full'"
              >
              <app-money-box [control]="form.controls['vatPerYear']"></app-money-box>
              <app-money-box [control]="form.controls['yearRentIncVat']"></app-money-box>
            </astral-layout-group>
          }
        }
        @if (isFixedPercentage) {
          <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
            <astral-input [control]="form.controls['fixedPercentageIncrease']" [type]="'number'"></astral-input>
            <app-date-picker
              [form]="fixedPercentageIncreaseStartForm"
              [title]="'LEASE_AGREEMENT_ROW.FIXED_PERCENTAGE_INCREASE_START'"
              [model]="row.fixedPercentageIncreaseStart"
            ></app-date-picker>
          </astral-layout-group>
        }
        <astral-layout-group [columns]="1" [mobileColumns]="1" [span]="'full'">
          <astral-input [control]="form.controls['invoiceText']" [helpText]="'LEASE_AGREEMENT_ROW.HELP_TEXT.INVOICE_TEXT'"></astral-input>
          @if (displayInvoiceRowGroup) {
            <astral-select
              [control]="form.controls['invoiceRowGroupId']"
              [itemsSource]="invoiceRowGroupSelection"
            ></astral-select>
          }
          @if (showProject) {
            <astral-input [control]="form.controls['project']"></astral-input>
          }
          <astral-textarea [control]="form.controls['note']" [helpText]="'LEASE_AGREEMENT_ROW.HELP_TEXT.NOTE'"></astral-textarea>
        </astral-layout-group>
      </div>
    </div>
    <footer class="astral-sidebar-footer">
      <astral-button variant="primary" [disabled]="isSubmitDisabled" type="submit" labelKey="LEASE_AGREEMENT_ROW.FORM_SUBMIT_BUTTON"></astral-button>
      <astral-button variant="secondary" (click)="cancel()" type="button" labelKey="CANCEL_BTN"></astral-button>
    </footer>
  </form>
}
